module.exports = __webpack_public_path__ + "img/NZ.2c05bbf5.svg";